import React from 'react'
import styles from './Navbar.module.css'

export default function FeedbackButton() {
  return (
    <button className={styles.FeedbackButton}>Give Feedback</button>
  )
}
